// ServDevelopData.js

// export const ServDevelopTopImg = [
//   // {
//   //   id: 0,
//   //   image: require('../images/ServiceImg/DevelopTop/ServDevelop-0.jpg'),
//   //   alt: 'images/ServiceImg/DevelopTop/ServDevelop-0.jpg',
//   // },
//   {
//     id: 1,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-1.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-1.jpg',
//   },
//   {
//     id: 2,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-2.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-2.jpg',
//   },
//   {
//     id: 3,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-4.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-4.jpg',
//   },
//   {
//     id: 4,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-8.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-8.jpg',
//   },
//   {
//     id: 5,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-9.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-9.jpg',
//   },
//   {
//     id: 6,
//     image: require('../images/ServiceImg/DevelopTop/DevelopTop-10.jpg'),
//     alt: 'images/ServiceImg/DevelopTop/DevelopTop-10.jpg',
//     link: 'https://xxxxxx.com/servicedevelop/xxxxxx',
//   },
// ]

export const ServDevelopTopTxt = [
  {
    id: 0,
    // image: require('../images/ServiceImg/DevelopeTop/ServDevelopXxxxxx.png'),
    // alt: 'images/ServiceImg/DevelopeTop/ServDevelopXxxxxx.png',
    name: 'P-Cap Touch Panel Manufacturing',
    title: '投射電容觸控面板(P-Cap Touch Panel)製造',
    subtitle: '適用於觸控面板生產與製造解決方案',
    text:
      '生产先進的觸控產品，以在惡劣的專業環境中實現最佳性能，同時滿足或超越法規遵循和品質保證。\n' +
      'HLZ Technology 工程、設計和製造團隊擁有精良的裝備，能夠實現公司多品種、小批量生產和快速成型的能力。\n' +
      '此外，我們的設施擁有 10,000 級無塵室，確保產品符合高可靠性應用所需的嚴格品質要求。\n' +
      '\n' +
      '',
    // nameEng: 'P-Cap Touch Panel Manufacturing',
    // titleEng: 'P-Cap Touch Panel Manufacturing',
    // subtitleEng: 'A touch panel production and manufacturing solutions',
    // textEng:
    //   '\n',
    describe: 'ServDevelopTop',
    // link: 'https://touchinternational.com/applications/#top',
    time: '2025/8/14',
  },
]

export const ServDevelopProductionImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/Production/DevelopProduction-1.jpg'),
    alt: 'images/ServiceImg/Production/vDevelopProduction-1.png',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/Production/DevelopProduction-2.jpg'),
    alt: 'images/ServiceImg/Production/DevelopProduction-2.png',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/Production/DevelopProduction-4.jpg'),
    alt: 'images/ServiceImg/Production/DevelopProduction-4.png',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/Production/DevelopProduction-6.jpg'),
    alt: 'images/ServiceImg/Production/DevelopProduction-6.png',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/Production/DevelopProduction-7.jpg'),
    alt: 'images/ServiceImg/Production/DevelopProduction-7.png',
    // link: '',
  },
]

export const ServDevelopProductionTxt = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelop-0.jpg'),
    alt: 'images/ServiceImg/ServDevelopProduction-0.jpg',
    name: 'Development/Production',
    title: 'Production',
    subtitle: '生产 / 制造\n',
    text:
      ' 为生产先进的触控产品，以在恶劣的专业环境中实现最佳性能，\n ' +
      ' 同时满足或超越法规遵循和质量保证。\n ' +
      ' HLZ在的专业工程、设计和制造团队拥有精良的装备，能够实现多品种、\n ' +
      ' 小批量生产和快速成型的能力。\n ' +
      ' 此外，我们的设施拥有10K级无尘室，确保产品符合\n ' +
      ' 高可靠性应用所需的严格质量要求。\n ' +
      ' 我们致力于打造业界可靠的产品，符合严格的ISO9001和ISOxxxxxx标准\n ' +
      ' ',
    describe: 'Service Develop Production',
    link: '',
    time: '2025/8/14',
  },
  {
    id: 1,
    // image: require('../images/ServiceImg/ServDevelop-1.jpg'),
    alt: 'images/ServiceImg/ServDevelopProduction-1.png',
    name: '１.適用於觸控面板生產與製造解決方案',
    title: '適用於觸控面板生產與製造解決方案',
    subtitle: '適用於觸控面板生產與製造解決方案',
    text:
      '\n' +
      '１.觸控面板生產要素：\n' +
      '      生產流程：\n' +
      '         以品質穩定為最高要求下，不斷改善流程達到良率與產能提升\n' +
      '      生產設備：\n' +
      '         依照生產流程選擇適當的生產設備，以縮減工時、\n' +
      '      生產設備：\n' +
      '         依照生產流程選擇適當的生產設備，以縮減工時、提升良率、效率與品質\n' +
      '      基材選擇：\n' +
      '         選擇合乎規範、尺寸、品質與價格合適的基材\n' +
      '      設計與開發：\n' +
      '         開發遵守EVT、DVT、PR、MP 4階段\n' +
      '      無塵的環境：\n' +
      '         印刷與貼合無塵等級100~1K，檢驗、加工、測試等要求達等级10K~100K\n' +
      '      SOP：\n' +
      '         生產作業指導書(SOP)、工作指令(Working Instruction)等全面完整，\n' +
      '         並嚴格遵守\n' +
      '      6S：\n' +
      '         整理(Seiri)、整頓(Seiton)、清掃(Seiso)、清潔(Seiketsu)、\n' +
      '         素養(Shitsuke)、安全(Safety)\n' +
      '      品質體系：\n' +
      '         QC、QA、QE，ISO9001、ISO14000、16949……\n' +
      '\n' +
      '２.觸控面板製造：\n' +
      '      從原料到最終產品，我們將探索創建電容式觸控螢幕的每個步驟。\n' +
      '         包括用於生產具有透明電極和各種塗層的靈敏電容式觸控面板的複雜技術。\n' +
      '         透過深入瞭解這項製造奇跡，您將欣賞到每臺設備的獨創性和精確性。\n' +
      '         因此，準備好揭開觸控摸屏製造秘密，將帶您從頭到尾經歷這段旅程。\n' +
      '         我們一起探索這一尖端工藝，看看触控面板如何徹底改變我們的數位世界\n' +
      '      在消费产品、手机平板、机器设备、交通工具等的输入装置，\n' +
      '         在技术上复杂且精密。对于PCap Touch Panel设计，\n' +
      '         有各种组件可供组装和整合。\n' +
      '         盖板、功能片、光学胶、光学黏合技术、机械整合及特定应用解决方案的\n' +
      '         选择起着重要作用。\n' +
      '         透过正确选择这些组件，可以开发出与应用程序最佳匹配的输入系统\n' +
      '      典型的触摸屏制造流程包括：\n' +
      '         保护盖板准备(玻璃清洁)、功能片(ITO)电极图案化、功能片银导线印刷、\n' +
      '         保护层应用、保护盖板与功能片压合以及外观检验和电器功能检验；\n' +
      '         其关键机制是透明导电层(氧化铟锡-ITO)，它会与手指产生静电场，\n' +
      '         可以检测触摸时的变化，从而实现触摸点识别\n' +
      '      关键步骤详述：\n' +
      '         ＊基材准备：选择装饰盖板、ITO玻璃(Sensor)、Fpc/Fpca、OCA/SCA等\n' +
      '         ＊清洁除尘：彻底清洁基材以去除任何可能影响印刷与贴合过程的污染物\n' +
      '         ＊功能片电极图案化：印刷与蚀刻技术在ITO图层上建立电极网格，\n' +
      '             定义触控感应区域\n' +
      '         ＊保护层：在电极图案上施加保护层，以防止刮伤并增强耐用性\n' +
      '         ＊质量检验：进行彻底的外观检验和电气测试，以确保触摸板正常运作\n' +
      '         ＊贴合：使用OCA/SCA将装饰盖板与功能片黏合，经真空压合固化\n' +
      '         ＊调适/校准：精确调适触控面板，使触控达到精确点击位置\n' +
      '         ＊OQC质量检验：进行彻底的外观检验和电气测试，以确保触摸板正常运作\n' +
      ' ',
  }
]

export const ServDevelopProcessFlow = [
  {
    id: 1,
    image: require('../images/ProcessFlow/ProcessFlowSensor.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowSensor.jpg',
    name: 'PCap Sensor Process Flow',
    title: 'PCap Sensor Process Flow',
    subtitle: 'PCap Sensor Process Flow',
    text:
      '   ＊ 功能片生產流程：\n' +
      '        • 來料外觀及功能檢驗\n' +
      '        • 印刷正反面蝕刻油墨\n' +
      '        • 蝕刻烘烤清洗、檢驗\n' +
      '        • 印刷正反面銀漿線、烘烤\n' +
      '        • 印刷正反面保護膜、烘烤\n' +
      '        • 正反面銀線雷射雕刻\n' +
      '        • 印刷正反面銀線絕緣保護\n' +
      '        • 外形切割、裂片成形\n' +
      '        • 假壓電測、熱壓FPC\n' +
      '        • 電氣測試、外觀檢驗\n' +
      '\n',
    describe: 'Service Develop PCap Sensor ProcessFlow',
    link: '',
    time: '2025/8/15',
  },
  {
    id: 2,
    image: require('../images/ProcessFlow/ProcessFlowTouch.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowTouch.jpg',
    // image: require('../images/ServiceImg/TPMProcFlow.png'),
    // alt: 'images/ServiceImg/TPMProcFlow.png',
    name: 'PCap Touch Panel Process Flow',
    title: 'PCap Touch Panel 生產流程',
    subtitle: 'PCap Touch Panel 生產流程',
    text:
      '   ＊ PCap Touch Panel 生產流程：\n' +
      '        • 來料外觀檢驗\n' +
      '        • 假壓電測\n' +
      '        • FPC熱壓、Bonding電測\n' +
      '        • 功能片貼附OCA\n' +
      '        • 蓋板烘烤、真空貼合、壓合\n' +
      '        • 貼合脫泡、外觀氣泡檢、UV固化\n' +
      '        • 外觀檢驗、電氣功能測試\n' +
      '        • 貼防爆膜\n' +
      '        • 貼保護膜、背膠加工\n' +
      '        • FQC外觀檢驗、電氣功能測試\n' +
      '        • OQC電氣功能、外觀檢批退\n' +
      '\n',
    describe: 'Service Develop Touch Panel ProcessFlow',
    link: '',
    time: '2025/2/20',
    // nameEng: '',
    // titleEng: '',
    // subtitleEng: '',
    // textEng:
    //   '\n' +
    // '\n',
  },
  {
    id: 3,
    image: require('../images/ProcessFlow/ProcessFlowTdm.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowTdm.jpg',
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'images/ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Touch Display Process Flow',
    title: 'Touch Display Process Flow',
    subtitle: 'Touch Display Process Flow',
    text:
      '   ＊ TP+LCM全貼合生產流程：\n' +
      '        • LCM來料外觀檢验\n' +
      '        • LCM点亮檢验\n' +
      '        • 触摸屏電測\n' +
      '        • OCA对位、贴附、检查\n' +
      '        • TP对位、贴附\n' +
      '        • 真空压合\n' +
      '        • 貼合脫泡、外觀氣泡檢、UV固化\n' +
      '        • TDM点亮檢验\n' +
      '        • TDM电测外观檢验\n' +
      '        • 扫码包装入库\n' +
      '\n',
    nameEng: '',
    titleEng: '',
    subtitleEng: '',
    textEng:
      '\n' +
      '\n',
    describe: 'Service Develop Touch Dislay Process Flow',
    link: '',
    time: '2025/8/15',
  },
]

// export const ServDevelopProduction = [
//   {
//     id: 0,
//     // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
//     // alt: 'images/ServiceImg/ServDevelopXxxxxxxxxx.png',
//     name: 'Touch Panel Manufacturing',
//     title: '觸控面板製造',
//     subtitle: '觸控面板生產要素',
//     text:
//       '     ＊ 生產流程：以品質穩定為最高要求下，不斷改善流程達到提升良率與產能提升\n' +
//       '     ＊ 生產設備：依照生產流程選擇適當的生產設備，以縮減工時、提升良率、效率與品質\n' +
//       '     ＊ 基材選擇：選擇合乎規範、尺寸、品質與價格合適的基材\n' +
//       '     ＊ 設計與開發：開發遵守EVT、DVT、PR、MP 4階段\n' +
//       '     ＊ 無塵的環境：印刷與貼合無塵等級100~1000級，檢驗、加工、測試等要求達到10K~100K\n' +
//       '     ＊ 生產作業指導書(SOP)、工作指令(Working Instruction)等全面完整，並嚴格遵守\n' +
//       '     ＊ 6S：整理(Seiri)、整頓(Seiton)、清掃(Seiso)、清潔(Seiketsu)、素養(Shitsuke)、安全(Safety)\n' +
//       '     ＊ 品質體系：QC、QA、QE\n' +
//       '\n' +
//       '\n',
//     nameEng: '',
//     titleEng: 'Touch Panel Manufacturing',
//     subtitleEng: 'Key Factors',
//     textEng:
//       '\n' +
//       '\n',
//     describe: 'ServDevelopProduction',
//     link: '',
//     time: '2025/2/17',
//   },
//   {
//     id: 1,
//     name: 'Touch Panel Manufacturing',
//     title: '觸控面板製造',
//     subtitle: '觸控面板製造',
//     text:
//       ' １. 從原料到最終產品，我們將探索創建電容式觸控螢幕的每個步驟。\n' +
//       '       這包括用於生產具有透明電極和各種塗層的靈敏且耐用的電容式觸控面板的複雜技術。\n' +
//       '       透過深入了解這項製造奇蹟，您將欣賞到每台設備的獨創性和精確性。\n' +
//       '       因此，請準備好揭開觸控螢幕製造的秘密，我們將帶您從頭到尾經歷這段迷人的旅程。\n' +
//       '       讓我們開始探索這一尖端工藝，看看液晶顯示面板如何徹底改變我們的數位世界。\n' +
//       '\n' +
//       ' ２. 消費產品、手機平板、機器設備、交通工具等的輸入系統在技術上複雜且精密。\n' +
//       '       然而，應用要求和技術不斷發展。對於 P-Cap Touch Panel 設計，有各種組件可供組裝和整合。\n' +
//       '       蓋板、P-Cap Sensor、顯示器、光學黏合技術、機械整合以及特定應用解決方案的選擇起著重要作用。\n' +
//       '       透過正確選擇這些組件，可以開發出與應用程式最佳匹配的輸入系統。\n' +
//       '\n',
//     nameEng: '',
//     titleEng: '',
//     subtitleEng: '',
//     textEng:
//       '\n' +
//       '\n',
//     describe: '',
//     link: 'https://touchinternational.com/applications/#top',
//     time: '2025/2/20',
//   },
// ]

// export const ServDevelopProcessFlow = [
//   {
//     id: 1,
//     image: require('../images/ServiceImg/ProcessFlowSensor.jpg'),
//     alt: 'images/ServiceImg/ProcessFlowSensor.jpg',
//     image: require('../images/ServiceImg/SensorProcFlow.png'),
//     alt: 'images/ServiceImg/SensorProcFlow.png',
//     name: 'Touch Panel Sensor Process Flow',
//     title: 'P-Cap Sensor Process Flow',
//     subtitle: 'Dito Sensor Process Flow',
//     text:
//       '     ＊ 功能片生產流程：\n' +
//       '          • 來料外觀及功能檢驗\n' +
//       '          • 印刷正反面蝕刻油墨\n' +
//       '          • 蝕刻烘烤清洗、檢驗\n' +
//       '          • 印刷正反面銀漿線、烘烤\n' +
//       '          • 印刷正反面保護膜、烘烤\n' +
//       '          • 正反面銀線雷射雕刻\n' +
//       '          • 印刷正反面銀線絕緣保護\n' +
//       '          • 外形切割、裂片成形\n' +
//       '          • 假壓電測、熱壓FPC\n' +
//       '          • 電氣測試、外觀檢驗\n' +
//       '\n',
//     nameEng: '',
//     titleEng: '',
//     subtitleEng: '',
//     textEng:
//       '\n' +
//       '\n',
//     describe: 'ServDevelopSensorProcFlow',
//     link: '',
//     time: '2025/2/20',
//   },
//   {
//     id: 2,
//     image: require('../images/ServiceImg/ProcessFlowTPM.jpg'),
//     alt: 'images/ServiceImg/ProcessFlowTPM.jpg',
//     // image: require('../images/ServiceImg/TPMProcFlow.png'),
//     // alt: 'images/ServiceImg/TPMProcFlow.png',
//     name: 'Touch Panel Process Flow',
//     title: 'P-Cap Touch 生產流程',
//     subtitle: 'P-Cap Touch Panel 生產流程',
//     text:
//       '     ＊ P-Cap Touch生產流程：\n' +
//       '          • 來料外觀檢驗\n' +
//       '          • 假壓電測\n' +
//       '          • FPC熱壓、Bonding電測\n' +
//       '          • 功能片貼附OCA\n' +
//       '          • 蓋板烘烤、真空貼合、壓合\n' +
//       '          • 貼合脫泡、外觀氣泡檢、UV固化\n' +
//       '          • 外觀檢驗、電氣功能測試\n' +
//       '          • 貼防爆膜\n' +
//       '          • 貼保護膜、背膠加工\n' +
//       '          • FQC外觀檢驗、FQC電氣功能測試\n' +
//       '          • OQC電氣功能、外觀檢批退\n' +
//       '\n',
//     nameEng: '',
//     titleEng: '',
//     subtitleEng: '',
//     textEng:
//       '\n' +
//       '\n',
//     describe: 'ServDevelopTouchProcFlow',
//     link: '',
//     time: '2025/2/20',
//   },
//   {
//     id: 3,
//     image: require('../images/ServiceImg/TDMProcFlow.png'),
//     alt: 'images/ServiceImg/TDMProcFlow.png',
//     // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
//     // alt: 'images/ServiceImg/ServDevelopXxxxxxxxxx.png',
//     name: 'Touch Display Process Flow',
//     title: 'Touch Display Process Flow',
//     subtitle: 'Touch Display Process Flow',
//     text:
//       '     ＊ TP+LCM全貼合生產流程：\n' +
//       '          • \n' +
//       '          • \n' +
//       '\n',
//     describe: 'ServDevelopTouchDislayProcFlow',
//     link: '',
//     time: '2025/2/20',
//   },
// ]

// export const ServDevelopDummy = [
//   {
//     id: 0,
//     // image: require('../images/ServiceImg/ServDevelop-0.jpg'),
//     alt: 'images/ServiceImg/ServDevelop-0.jpg',
//     name: 'Services/Development',
//     title: 'Services/Development',
//     subtitle: '生产/制造\n',
//     text:
//     ' 生产先进的触控产品，以在恶劣的专业环境中实现最佳性能，同时满足或超越法规遵循和质量保证。HLZ在中国的专业工程、\n' +
//     '',
//     describe: 'ServDevelopProduction',
//     link: '',
//     time: '2025/8/14',
//   },
//   {
//     id: 1,
//     // image: require('../images/ServiceImg/ServDevelop-1.jpg'),
//     alt: 'images/ServiceImg/ServDevelopTouch.png',
//     name: '１.適用於觸控面板生產與製造解決方案',
//     title: '適用於觸控面板生產與製造解決方案',
//     subtitle: '適用於觸控面板生產與製造解決方案',
//     text:
//       '１.XXXXXXXXXX 觸控面板生產要素：\n' +
//       '      XXXXXXXX 生產流程：以品質穩定為最高要求下，不斷改善流程達到提升良率與產能提升\n' +
//       '      XXXXXXXX 生產設備：依照生產流程選擇適當的生產設備，以縮減工時、提升良率、效率與品質\n' +
//       '２.XXXXXXXXXX 觸控面板製造：\n' +
//       '      XXXXXXXX 從原料到最終產品，我們將探索創建電容式觸控螢幕的每個步驟。\n' +
//       '         xxxxxx 包括用於生產具有透明電極和各種塗層的靈敏且耐用的電容式觸控面板的複雜技術。\n' +
//       '      XXXXXXXX 消費產品、手機平板、機器設備、交通工具等的輸入系統在技術上複雜且精密。然而，應用要求和技術不斷發展。\n' +
//       '         xxxxxx 對於投射电容触摸屏(PCap Touch Panel)設計，有各種組件可供組裝和整合。\n' +
//       '         xxxxxx 蓋板、功能片(PCap Sensor)、顯示器、光學黏合技術、機械整合以及特定應用解決方案的選擇起著重要作用。\n' +
//       '\n' +
//       '      XXXXXXXX 光学胶：\n' +
//       '          ＊  xxxx 连接盖板与功能片\n' +
//       '          ＊  XXXXXXXX\n' +
//       '      XXXXXXXX 功能片：\n' +
//       '          ＊  xxxx 电极层(X,Y grid)，于盖板下方\n' +
//       '          ＊  xxxx 上层电极层\n' +
//       '          ＊  xxxx 玻璃基板\n' +
//       '　',
//   },
// ]

export const ServDevelopEquipmentTop = [
  {
    id: 0,
    // image: require('../images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg'),
    alt: 'images/ServiceImg/Equipment/A-01-A-01-蚀刻清洗机.jpg',
    // alt: 'images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg',
    name: 'Production Equipment',
    title: '設備',
    // subtitle: '',
    text:
      '\n' +
      '',
  },
]

export const ServDevelopEquipmentImg = [
  {
    id: 1,
    image: require('../images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg'),
    alt: 'images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg',
    altCHS: 'images/ServiceImg/Equipment/A-01-蚀刻清洗机.jpg',
  },
  // {
  //   id: 2,
  //   image: require('../images/ServiceImg/Equipment/A-03-EtchingCleanLine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/A-03-EtchingCleanLine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/A-03-蚀刻清洗机.jpg',
  // },
  // {
  //   id: 3,
  //   image: require('../images/ServiceImg/Equipment/A-05-Etching&CleanMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/A-05-Etching&CleanMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/A-05-蚀刻清洗机.jpg',
  // },
  {
    id: 4,
    image: require('../images/ServiceImg/Equipment/B-04-ScreenPrintMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/B-04-ScreenPrintMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/B-04-网板印刷机.jpg',
  },
  // {
  //   id: 5,
  //   image: require('../images/ServiceImg/Equipment/B-06-AutoScreenPrintLine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/B-06-AutoScreenPrintLine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/B-06-自动丝印线.jpg',
  // },
  // {
  //   id: 6,
  //   image: require('../images/ServiceImg/Equipment/B-32-ScreenPringingLine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/B-32-ScreenPringingLine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/B-32-自动丝印线.jpg',
  // },
  {
    id: 7,
    image: require('../images/ServiceImg/Equipment/B-33-AutoScreenPrintLine.jpg'),
    alt: 'images/ServiceImg/Equipment/B-33-AutoScreenPrintLine.jpg',
    altCHS: 'images/ServiceImg/Equipment/B-33-自动丝印线.jpg',
  },
  // {
  //   id: 8,
  //   image: require('../images/ServiceImg/Equipment/B-34-AutoScreenPrintLine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/B-34-AutoScreenPrintLine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/B-34-自动丝印线.jpg',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ServiceImg/Equipment/B-35-ScreenPrintingMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/B-35-ScreenPrintingMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/B-35-网板印刷机.jpg',
  // },
  {
    id: 10,
    image: require('../images/ServiceImg/Equipment/C-09-AirFlowOven.jpg'),
    alt: 'images/ServiceImg/Equipment/C-09-AirFlowOven.jpg',
    altCHS: 'images/ServiceImg/Equipment/C-09-热风烤箱.jpg',
  },
  // {
  //   id: 11,
  //   image: require('../images/ServiceImg/Equipment/C-23-AirFlowOven.jpg'),
  //   alt: 'images/ServiceImg/Equipment/C-23-AirFlowOven.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/C-23-热风烤箱.jpg',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ServiceImg/Equipment/C-27-AirFlowOven.jpg'),
  //   alt: 'images/ServiceImg/Equipment/C-27-AirFlowOven.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/C-27-热风烤箱.jpg',
  // },
  // {
  //   id: 13,
  //   image: require('../images/ServiceImg/Equipment/C-37-DustFreeOven.jpg'),
  //   alt: 'images/ServiceImg/Equipment/C-37-DustFreeOven.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/C-37-无尘烤箱.jpg',
  // },
  {
    id: 14,
    image: require('../images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/C-39-UV固化机.jpg',
  },
  // {
  //   id: 15,
  //   image: require('../images/ServiceImg/Equipment/D-08-AutoClaveMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/D-08-AutoClaveMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/D-08-脱泡机.jpg',
  // },
  {
    id: 16,
    image: require('../images/ServiceImg/Equipment/D-22-AutoClaveMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/D-22-AutoClaveMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/D-22-高压脱泡机.jpg',
  },
  // {
  //   id: 17,
  //   image: require('../images/ServiceImg/Equipment/E-10-7inchFlipPlateLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-10-7inchFlipPlateLaminator.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-10-7.0吋翻板贴合机.jpg',
  // },
  // {
  //   id: 18,
  //   image: require('../images/ServiceImg/Equipment/E-11-10inchLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-11-10inchLaminator.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-11-10吋贴片机.jpg',
  // },
  {
    id: 19,
    image: require('../images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator.jpg'),
    alt: 'images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator-.jpg',
    altCHS: 'images/ServiceImg/Equipment/E-12-15吋双工位翻板贴合机.jpg',
  },
  // {
  //   id: 20,
  //   image: require('../images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
  //   alt: 'images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-13-15吋翻板贴合机.jpg',
  // },
  // {
  //   id: 21,
  //   image: require('../images/ServiceImg/Equipment/E-14-32inchFlipPlateLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-14-32inchFlipPlateLaminator.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-14-32吋翻板贴合机.jpg',
  // },
  {
    id: 22,
    image: require('../images/ServiceImg/Equipment/E-20-FlipPlateLaminator.jpg'),
    alt: 'images/ServiceImg/Equipment/E-20-FlipPlateLaminator.jpg',
    altCHS: 'images/ServiceImg/Equipment/E-20-翻版贴合机.jpg',
  },
  // {
  //   id: 23,
  //   image: require('../images/ServiceImg/Equipment/E-28-Laminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-28-Laminator.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-28-贴片机.jpg',
  // },
  // {
  //   id: 24,
  //   image: require('../images/ServiceImg/Equipment/F-15-ACFAttachEquipment.jpg'),
  //   alt: 'images/ServiceImg/Equipment/F-15-ACFAttachEquipment.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/F-15-ACF热贴附机.jpg',
  // },
  {
    id: 25,
    image: require('../images/ServiceImg/Equipment/F-16-FPCBondingMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/F-16-FPCBondingMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/F-16-热压机.jpg',
  },
  // {
  //   id: 26,
  //   image: require('../images/ServiceImg/Equipment/E-26-SCALaminatMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-26-SCALaminatMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/E-26-SCA贴合机.jpg',
  // },
  // {
  //   id: 27,
  //   image: require('../images/ServiceImg/Equipment/G-19-LaserCuttingMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/G-19-LaserCuttingMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/G-19-激光雕刻机.jpg',
  // },
  {
    id: 28,
    image: require('../images/ServiceImg/Equipment/G-21-LaserCuttingMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/G-21-LaserCuttingMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/G-21-激光机雕刻机.jpg',
  },
  // {
  //   id: 29,
  //   image: require('../images/ServiceImg/Equipment/G-29-GlassCutter.jpg'),
  //   alt: 'images/ServiceImg/Equipment/G-29-GlassCutter.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/G-29-玻璃切割机.jpg',
  // },
  // {
  //   id: 30,
  //   image: require('../images/ServiceImg/Equipment/H-24-HiTempAgingChamber.jpg'),
  //   alt: 'images/ServiceImg/Equipment/H-24-HiTempAgingChamber.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/H-24-高温老化试验箱.jpg',
  // },
  {
    id: 31,
    image: require('../images/ServiceImg/Equipment/H-25-HLTempTestChamber.jpg'),
    alt: 'images/ServiceImg/Equipment/H-25-HLTempTestChamber.jpg',
    altCHS: 'images/ServiceImg/Equipment/H-25-高低温测试设备.jpg',
  },
  {
    id: 32,
    image: require('../images/ServiceImg/Equipment/H-31-ThermalShockChamber.jpg'),
    altCHS: 'images/ServiceImg/Equipment/H-31-冷热冲击测试机.jpg',
    alt : 'images/ServiceImg/Equipment/H-31-ThermalShockChamber.jpg',
  },
  // {
  //   id: 33,
  //   image: require('../images/ServiceImg/Equipment/I-18-TPTestingEquipment.jpg'),
  //   alt: 'images/ServiceImg/Equipment/I-18-TPTestingEquipment.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/I-18-TP电气功能测试设备.jpg',
  // },
  {
    id: 34,
    image: require('../images/ServiceImg/Equipment/I-36-TPTestingMachine.jpg'),
    alt: 'images/ServiceImg/Equipment/I-36-TPTPTestingMachine.jpg',
    altCHS: 'images/ServiceImg/Equipment/I-36-TP电气功能测试设备.jpg',
  },
  // {
  //   id: 35,
  //   image: require('../images/ServiceImg/Equipment/I-38-SensorTestingMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/I-38-SensorTestingMachine.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/I-38-Sensor假压测试机.jpg',
  // },
  // {
  //   id: 36,
  //   image: require('../images/ServiceImg/Equipment/J-02-ImageCircuitInspector.jpg'),
  //   alt: 'images/ServiceImg/Equipment/J-02-ImageCircuitInspector.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/J-02-放大镜线路检查机.jpg',
  // },
  // {
  //   id: 37,
  //   image: require('../images/ServiceImg/Equipment/J-07-2DMeasureInstrument.jpg'),
  //   alt: 'images/ServiceImg/Equipment/J-07-2DMeasureInstrument.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/J-07-二次元检测仪.jpg',
  // },
  // {
  //   id: 38,
  //   image: require('../images/ServiceImg/Equipment/J-17-2DMeasueInstrument.jpg'),
  //   alt: 'images/ServiceImg/Equipment/J-17-2DMeasureInstrument.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/J-17-二次元检测设仪.jpg',
  // },
  // {
  //   id: 39,
  //   image: require('../images/ServiceImg/Equipment/J-30-ImageCircuitInspector.jpg'),
  //   alt: 'images/ServiceImg/Equipment/J-30-ImageCircuitInspector.jpg',
  //   altCHS: 'images/ServiceImg/Equipment/J-30-放大镜线路检查仪.jpg',
  //   // link: '',
  // },
]

export const ServDevelopEquipmentTxt = [
  {
    id: 1,
    // image: require('../images/ServEquipImg/A-01-EtchingCleanLine.jpg'),
    // alt: 'ServEquipImg/A-01-蚀刻清洗机.jpg',
    // alt: 'ServEquipImg/A-01-EtchingCleanLine.jpg',
    name: '１.４.１. 生產設備(Production Equipment)',
    title: '生产设备',
    // subtitle: '',
    text:
      '生产设备\n' +
      '  網板印刷機(大尺寸，如65吋以上)：\n' +
      '     印刷機構設計優化，網版設計距絲印產品1~3mm,印刷過程中變形小，\n' +
      '     尺寸更穩定，網版壽命更高全過程雙人工放片，避免因尺寸過大，\n' +
      '     在作業過程中造成破損或其他不良，印刷良率高\n' +
      '  蝕刻清洗機(提升產品良率與可靠性)：\n' +
      '     通過精准控制清洗力度(如噴淋壓力、超聲頻率)和清洗介質\n' +
      '     (如純水、化學清洗劑)，在高效去汙的同時避免損傷工件表面\n' +
      '     (如ITO 膜層、半導體線路)，減少因污染或腐蝕導致的產品缺陷，\n' +
      '     適配高精度電子元件對表面潔淨度的嚴苛要求\n' +
      '  UV固化機：\n' +
      '     在觸摸屏(Touch Panel)的生產製造中，UV固化機通過紫外線照射\n' +
      '     引發UV固化材料(如油墨、膠水、塗層等)的化學聚合反應，\n' +
      '     實現材料快速固化，是保障TP性能、精度和生產效率的關鍵設備\n' +
      '  無塵烤箱：\n' +
      '     結合"无尘+精准溫控"，其作用不僅是完成加熱、烘乾、固化等基礎工藝，\n' +
      '     在生产過程中杜絕微粒污染，並保證工藝一致性，從而保障高精密\n' +
      '     產品的性能，可靠性和生產良率。在光电、電子等高端製造領域，\n' +
      '     它是實現精細化生產的關鍵設備之一\n' +
      '  翻板貼合機：\n' +
      '     ＊高精度對位貼合：\n' +
      '     ＊無氣泡貼合：\n' +
      '     ＊適配輕薄材料：\n' +
      '     ＊提升生產效率：\n' +
      '  貼片機：\n' +
      '     ＊高精度對位貼合：\n' +
      '     ＊低應力貼合：\n' +
      '     ＊無氣泡控制：\n' +
      '     ＊適配柔性與剛性材料：\n' +
      '  雷射雕刻機：\n' +
      '     雕刻ITO(氧化銦錫)圖案，根據設計要求，使用鐳射光刻技術\n' +
      '     在已鍍好ITO的玻璃上雕刻出特定的电路圖案，去除無用的ITO部分，\n' +
      '     保留的圖案用作觸摸屏Sensor的導通線路，實現觸摸感應等功能。\n' +
      '     加工邊緣走線，在ITO圖案邊緣通過絲網印刷銀漿並烘烤後，\n' +
      '     利用鐳射雕刻機鐳射出具有特定線寬線距的線路，形成邊緣走線，\n' +
      '     使銀漿線路與面內圖案通道相連，可解決傳統蝕刻工藝中存在的\n' +
      '     斷線、蝕刻不淨等問題\n' +
      '  玻璃切刻機：\n' +
      '     通過刀輪、鐳射等切割工具，將大塊玻璃按照預設尺寸或形狀精准分割，\n' +
      '     同時減少切割過程中的崩邊、裂紋等損傷；其能適配不同厚度、\n' +
      '     類型的玻璃(如平板、鋼化、觸摸屏玻璃等)，為後續加工(如磨邊、鍍膜)\n' +
      '     提供符合規格的玻璃坯料，是玻璃深加工流程中的基礎設備\n' +
      '  本壓機：\n' +
      '     用於FPC與ITO Sensor的壓接，通過均勻施壓使兩者的導電端子緊密接觸，\n' +
      '     保障信號傳輸穩定。\n' +
      '     本壓機的作用是通過可控加壓(配合溫度調節)實現FPC、功能片的緊密貼合、\n' +
      '     固定或密封，對連接精度和一致性要求高的行業，是保障產品性能和穩定性\n' +
      '     的關鍵設備。\n' +
      '  ACF打膠機:\n' +
      '     為了能讓ITO黏貼上在ACF(異方性導電膠膜)上。ITO是一種高透明導电材料，\n' +
      '     具有高的導電率、高的可見光透過率、高的機械硬度和良好的化學穩定性。\n' +
      '  FPC熱壓機：\n' +
      '     FPC熱壓機是通過精確控制溫度、壓力和時間，對FPC與其他部件\n' +
      '     (如連接器、覆蓋膜、ITO 玻璃等)進行熱壓貼合，使接觸面在高溫高壓下\n' +
      '     實現牢固結合(如粘合劑熔融固化、金屬焊點焊接)；確保压合部位的平整性、\n' +
      '     導電性和力學穩定性，有效解決人工貼合的精度不足、結合強度低等問題\n' +
      '  壓合機：\n' +
      '     壓合機的作用是通過可控的壓力(配合溫度、時間等參數)，\n' +
      '     使不同材料或部件實現緊密結合，形成具有特定結構、性能的整體。\n' +
      '     其應用場景雖多樣，但本質都是利用壓力消除材料間的間隙、\n' +
      '     促進粘結(或固化)，最終保障產品的結構強度、密封性、功能性及外觀品質，\n' +
      '     是工業生產中實現材料複合與部件成型的關鍵設備\n' +
      '  SCA壓合機：\n' +
      '     SCA壓合機主要用於觸摸屏部件的貼合工藝，其作用是通過施加壓力，\n' +
      '     將帶有SCA光學膠的功能片與保護蓋板緊密貼合在一起，確保貼合效果良好，\n' +
      '     無氣泡、無偏移，提升產品的性能和品質\n' +
      '  消泡爐：\n' +
      '     壓合機負責貼合，確保材料定位精准、膠層附著；\n' +
      '     消泡爐則解決壓合後殘留的小氣泡，通過熱与压力，進一步提升貼合的緻密性。\n' +
      '     二者結合可大幅降低產品不良率，是精密製造中保障貼合品質的關鍵環節\n' +
      '  中尺寸(15.6吋)翻板貼合機：\n' +
      '     翻板貼合機的作用是通過翻板翻轉結構實現中大尺寸的高精度對位與平穩貼合，\n' +
      '     尤其適用於對定位精度和材料安全性要求高的場景，是大尺寸顯示、\n' +
      '     柔性面板等領域不可或缺的生產設備\n' +
      '  全自動貼合機：\n' +
      '     全自動貼合機是以全自動化操作和高精度控制，實現多種材料的高效、無缺陷、\n' +
      '     一致性貼合，是電子光學等精密製造領域實現規模化、高質量生產的關鍵設備\n' +
      '  除膠機:\n' +
      '     通過專業化設備，高效、徹底、安全地清除物體表面的各類殘膠，\n' +
      '     既保障產品外觀和後續加工品質，又提升工業生產、維修、回收環節的效率，\n' +
      '     是現代製造業中解決“殘膠難題”的關鍵設備\n' +
      '  中大尺寸(21.6吋)翻板貼合機：\n' +
      '     通過翻板翻轉机構實現大尺寸、複雜材料的高精度對位與平穩貼合，\n' +
      '     尤其適用於對定位精度和材料安全性要求高的場景，是大尺寸顯示、\n' +
      '     柔性電子等領域不可或缺的生產設備\n' +
      '  大尺寸(32吋)翻板貼合機：\n' +
      '     通過翻板翻轉机構實現大尺寸、複雜材料的高精度對位與平穩貼合，\n' +
      '     尤其適用於對定位精度和材料安全性要求高的場景，是大尺寸顯示、\n' +
      '     柔性電子等領域不可或缺的生產設備\n' +
      '  貼膜機：\n' +
      '     通過機械化手段，高效、精准地將各類薄膜貼合到物體表面，\n' +
      '     既滿足保護(防刮、防塵)、裝飾(美觀、個性化)的基礎需求，\n' +
      '     也能提升工業生產中的一致性和效率，\n' +
      '     是現代製造業和服務業中不可或缺的輔助設備\n' +
      '  覆膜機：\n' +
      '     覆膜機的作用是通過薄膜與基材的複合，為基材提供防護、美化、\n' +
      '     功能增強等效果，是連接基礎材料與終端產品的關鍵設備，\n' +
      '     在各行各業中通過“覆膜”這一簡單工藝，顯著提升產品的實用性、\n' +
      '     耐用性和附加值\n' +
      '  中尺寸(15.6吋)真空貼合機：\n' +
      '     真空貼合機是在真空環境中實現高精度、無氣泡的材料貼合，\n' +
      '     是光學等精密製造領域中保障產品性能和外觀的關鍵設備，\n' +
      '     其通過“排除空氣+精准控制”，解決了貼合工藝中難以避免的氣泡、\n' +
      '     褶皺等問題，為高附加值產品的生產和修復提供了技術支持\n' +
      '  OCA貼合機：\n' +
      '     OCA貼合機是通過高精度定位和均勻壓合，實現 OCA 膠與各類基材的無氣泡、\n' +
      '     高一致性貼合，是保障觸摸屏、顯示幕等光學電子器件品質的關鍵設備\n' +
      '  電氣功能測試設備：\n' +
      '     電氣功能測試設備是電子製造領域中用於檢測電子元器件、線路板、\n' +
      '     整機產品等電氣性能是否符合設計標準的專用設備，通過模擬實際工作環境，\n' +
      '     對產品的電路連通性、信號傳輸、功能邏輯、參數指標等進行自動化或半\n' +
      '     自動化檢測，作用是篩選出存在短路、斷路、性能異常等缺陷的產品，\n' +
      '     保障出廠品質\n' +
      '     ＊FPC Tester：FPC短路、开路测试，烧录功能测试，IC局部功能测试，。。。\n' +
      '     ＊Sensor Tester：假压测试，容值测试，短路、开路测试，。。。\n' +
      '     ＊TP Tester：容值测试，功能测试，燥声测试，。。。\n' +
      ' '
  },
  {
    id: 2,
    // image: require('../images/ServEquipImg/H-24-HiTempAgingChamber.jpg'),
    // alt: 'ServEquipImg/H-24-高温老化试验箱.jpg',
    // alt: 'ServEquipImg/H-24-HiTempAgingChamber.jpg',
    name: '１.４.２. 環測設備：',
    title: '環測設備',
    text:
      '環測設備\n' +
      '  高溫試驗箱：\n' +
      '     能模擬高溫，用於測試產品在高溫下的性能變化，比如電子元件在高溫下\n' +
      '     是否會出現短路及是否會失去功能\n' +
      '  低溫試驗箱：\n' +
      '     能模擬低溫，用於測試產品在低溫下的性能變化，比如電子元件在低溫下\n' +
      '     是否會出現功能异常\n' +
      '  恒溫恒濕試驗箱：\n' +
      '     可控制溫度和濕度的穩定，模擬不同溫濕度組合的環境，南方潮濕高溫的夏季、\n' +
      '     北方乾燥寒冷的冬季等，常用於測試紡織品、電子產品的防潮、耐濕性能\n' +
      '  高低溫濕熱試驗箱：\n' +
      '     高低溫濕熱試驗箱的作用是通過模擬極端或交變的溫濕度環境，\n' +
      '     評估產品在不同氣候條件下的性能穩定與可靠性。\n' +
      '     它幫助企業在產品上市前發現因溫濕度應力導致的潛在缺陷\n' +
      '     (如結構開裂、電氣故障、功能失效)，縮短研發週期，降低售後風險，\n' +
      '     最終保障產品在用戶實際使用場景中的安全性和耐用性，\n' +
      '     是製造業中驗證產品環境適應性的核心設備\n' +
      '  冷熱衝擊測試設備：\n' +
      '     冷熱衝擊試驗箱的作用是通過模擬快速溫度變化環境，\n' +
      '     評估產品在極端溫差下的結構穩定性、材料相容性和功能可靠性，\n' +
      '     提前發現因熱應力、材料性能差異導致的潛在缺陷，為產品設計優化\n' +
      '     (如選用更耐溫差的材料、改進結構密封性)提供數據支持，最終保障產品在\n' +
      '     複雜環境中的使用壽命和安全性，是製造業中驗證產品環境適應性的關鍵設備\n' +
      '  跌落測試機：\n' +
      '     跌落測試機的作用是通過模擬真實跌落衝擊，為產品設計優化、\n' +
      '     包裝防護驗證、品質一致性檢測提供量化數據支持，最終目的是確保產品\n' +
      '     在流通和使用過程中能夠承受合理範圍內的跌落衝擊，減少損壞風險，\n' +
      '     保障用戶體驗與企業品牌信譽，是製造業中保障產品可靠性的關鍵測試設備\n' +
      '  氙燈老化實驗機：\n' +
      '     氙燈老化實驗機的作用是通過模擬自然陽光和氣候條件，\n' +
      '     加速材料或產品的老化過程，快速評估其耐候性和使用壽命，\n' +
      '     幫助企業產品上市前發現因光、熱、濕度導致的老化缺陷(如褪色、開裂等)，\n' +
      '     為材料篩選、配方和結構改進提供數據，保障產品在戶外環境中的長期可靠性，\n' +
      '     是製造業中驗證產品耐候性能的關鍵設備\n' +
      '  鹽霧實驗箱：\n' +
      '     鹽霧實驗箱的作用是通過模擬高鹽潮濕的腐蝕環境，\n' +
      '     加速材料或產品的腐蝕過程，快速評估其抗腐蝕性能。幫助企業在產品研發、\n' +
      '     生產環節發現耐蝕性缺陷(如鍍層不均、密封失效)，優化材料選擇和工藝設計，\n' +
      '     最終確保產品在沿海、工業污染等高腐蝕環境中具有足夠的使用壽命和可靠性，\n' +
      '     是製造業中驗證產品抗腐蝕能力的關鍵設備\n' +
      '',
  },
  {
    id: 3,
    // image: require('../images/ServEquipImg/J-07-2DMeasueInstrument.jpg'),
    // alt: 'images/ServEquipImg/Equipment/J-07-二次元检测仪.jpg',
    // alt: 'images/ServEquipImg/Equipment/J-07-2DMeasureInstrument.jpg',
    name: '１.４.３. 檢測設備：',
    title: '檢測設備',
    text:
      '檢測設備\n' +
      '  二次元量測設備：\n' +
      '     二次元測量設備的作用是為工業生產中的二維幾何量檢測提供高精度、\n' +
      '     高效率、非接觸式的解決方案，通過精准把控工件的尺寸、形狀和位置精度，\n' +
      '     保障產品品質穩定性、降低廢品率，並為生產工藝改進提供數據支持，\n' +
      '     是精密製造領域不可或缺的品質檢測工具\n' +
      '  TP電氣測試工作站：\n' +
      '     XXXXXXXXXX\n' +
      '  LCM點亮設備：\n' +
      '     XXXXXXXXXX\n' +
      '  晶像儀：\n' +
      '     XXXXXXXXXX\n' +
      '  Sensor線路放大檢測設備：\n' +
      '     用於放大光看ITO Sensor線路/綁定FPC氣泡等\n' +
      '  應力測試儀：\n' +
      '     應力測試儀的作用是將物體的應力狀態“可視化”和“量化”，\n' +
      '     幫助用戶發現潛在的應力隱患(如應力集中、殘餘應力過高)，\n' +
      '     評估材料或結構的安全性與可靠性，優化製造工藝和設計方案。\n' +
      '     無論是產品研發、生產質控還是使用維護，它都是保障物體在受力\n' +
      '     或環境變化下穩定運行的關鍵工具\n' +
      '  電動鉛筆硬度計：\n' +
      '     電動鉛筆硬度計是用於通過標準化測試量化表面覆蓋層的抗刮擦能力，\n' +
      '     為產品研發中的材料篩選、生產過程中的品質控制、以及產品是否符合\n' +
      '     行業標準提供科學依據，最終保障產品在實際使用中的耐用性和可靠性\n' +
      '  拉力實驗機：\n' +
      '     拉力試驗機的作用是通過科學的拉伸測試，量化材料的力學性能，\n' +
      '     為材料選擇、產品設計、生產品質控制和合規認證提供數據支持。\n' +
      '     無論是驗證一根鋼筋的承重能力，還是評估一款新型塑膠的耐用性，\n' +
      '     拉力試驗機都能通過精准的力值和位移測量，揭示材料的“力學本質”，\n' +
      '     最終保障產品的安全性、可靠性和適用性\n' +
      '  靜電放電發生器：\n' +
      '     靜電發生器的作用是模擬靜電放電干擾，量化電氣設備的抗靜電能力，\n' +
      '     測試結果直接關係到產品的安全性、可靠性和市場准入資格。\n' +
      '     無論是產品研發中的設計優化、生產過程中的品質把控，\n' +
      '     還是符合國際國內標準的合規性認證，都離不開靜電放電發生器\n' +
      '     提供的科學數據支持\n' +
      ' ',
    describe: 'Production Equipment',
  },
]

export const ServDevelopEquipmentPhoto = [
  {
    id: 1,
    image: require('../images/ServiceImg/Equipment/B-04-ScreenPrintMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/B-04-网板印刷机.jpg',
    alt: 'images/ServiceImg/Equipment/B-04-ScreenPrintMachine.jpg',
    name: 'Mesh Printing Machine',
    title: '網版印刷機',
    subtitle: 'Screen Print Machine',
    describe: '網版印刷機',
    detail: '網版印刷機:功能說明及使用製程',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/Equipment/B-06-AutoScreenPrintLine.jpg'),
    // alt: 'images/ServiceImg/Equipment/B-06-自动丝印线.jpg',
    alt: 'images/ServiceImg/Equipment/B-06-AutoScreenPrintLine.jpg',
    name: 'Auto Screen Print Machine',
    title: '自动网板印刷线',
    subtitle: 'Auto Screen Printing Line',
    describe: '自动网板印刷线',
    detail: '印刷银线、蝕刻膏、絕緣、保護層....',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/Equipment/B-32-ScreenPringingLine.jpg'),
    // alt: 'images/ServiceImg/Equipment/B-32-自动丝印线.jpg',
    alt: 'images/ServiceImg/Equipment/B-32-ScreenPringingLine.jpg',
    name: 'Auto Screen Print Machine',
    title: '自动网板印刷线',
    subtitle: 'Auto Screen Print Machine',
    describe: '自动网板印刷线',
    detail: '印刷银线、蝕刻膏、絕緣、保護層....',
  },
  {
    id: 4,
    image: require('../images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg'),
    // alt: 'images/ServiceImg/Equipment/A-01-蚀刻清洗机.jpg',
    alt: 'images/ServiceImg/Equipment/A-01-EtchingCleanLine.jpg',
    name: 'Etching & Clean Line',
    title: '蝕刻清洗線線',
    subtitle: '蝕刻清洗線線',
    describe: 'Etching and Cleaning Line',
    detail: '蝕刻清洗線:功能說明及使用製程',
  },
  {
    id: 5,
    image: require('../images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/C-39-UV固化机.jpg',
    alt: 'images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg',
    name: 'UV Light Curing Machine',
    title: 'UV固化機',
    subtitle: 'UV固化機',
    describe: 'UV Light Curing Machine',
    detail: 'UV固化機:功能說明及使用製程',
  },
  // {
  //   id: 6,
  //   image: require('../images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/C-39-UV固化机.jpg',
  //   // alt: 'images/ServiceImg/Equipment/C-39-UVCuringMachine.jpg',
  //   name: 'UV Light Curing Machine',
  //   title: 'UV固化機',
  //   subtitle: 'UV Light Curing Machine',
  //   detail: 'UV固化機:功能說明及使用製程',
  //   describe: 'UV固化機',
  // },
  // {
  //   id: 7,
  //   image: require('../images/ServiceImg/Equipment/C-09-AirFlowOven.jpg'),
  //   alt: 'images/ServiceImg/Equipment/C-09-热风烤箱.jpg',
  //   // alt: 'images/ServiceImg/Equipment/C-09-AirFlowOven.jpg',
  //   name: 'Convection Oven',
  //   title: '烘烤箱',
  //   subtitle: 'Convection Oven',
  //   describe: '热风烤箱',
  //   detail: '烘烤各种印刷物件',
  // },
  {
    id: 8,
    image: require('../images/ServiceImg/Equipment/C-27-AirFlowOven.jpg'),
    // alt: 'images/ServiceImg/Equipment/C-27-热风烤箱.jpg',
    alt: 'images/ServiceImg/Equipment/C-27-AirFlowOven.jpg',
    name: 'Air Flow Oven',
    title: '热风烤箱',
    subtitle: '热风烤箱',
    describe: 'Air Flow Oven',
    detail: '烘烤各种印刷物件',
  },
  {
    id: 9,
    image: require('../images/ServiceImg/Equipment/C-37-DustFreeOven.jpg'),
    // alt: 'images/ServiceImg/Equipment/C-37-无尘精密烤箱.jpg',
    alt: 'images/ServiceImg/Equipment/C-37-DustFreeOven.jpg',
    name: 'Oxidation Free Force Air Oven',
    title: '无尘精密热风循环烤箱',
    subtitle: 'Oxidation Free Force Air Oven',
    describe: '无尘精密热风循环烤箱',
    detail: '无尘室用热风烤箱，烘烤各种印刷物件',
  },
  {
    id: 10,
    image: require('../images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-12-15吋双工位翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator.jpg',
    name: 'Flap Laminating Machine',
    title: '15.0吋双工位翻板贴合机',
    subtitle: '15 inch Flap Laminating Machine',
    // subtitle: '15 inch Flip Plate Laminator',
    describe: '翻板貼合機',
    detail: '翻板貼合機',
  },
  {
    id: 11,
    image: require('../images/ServiceImg/Equipment/E-11-10inchLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-11-10吋贴片机.jpg',
    alt: 'images/ServiceImg/Equipment/E-11-10inchLaminator.jpg',
    name: '10 Inch Lamination Machine',
    title: '10 Inch Lamination Machine',
    subtitle: '10 Inch Lamination Machine',
    describe: '10吋(Small)贴片机',
    detail: '贴片机(7~12吋)',
  },
  {
    id: 12,
    image: require('../images/ServiceImg/Equipment/G-19-LaserCuttingMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/G-19-激光雕刻机.jpg',
    alt: 'images/ServiceImg/Equipment/G-19-LaserCuttingMachine.jpg',
    name: 'Laser Engraving Machine',
    title: '雷射雕刻機',
    subtitle: 'Laser Engraving Machine',
    describe: '雷射雕刻機',
    detail: '雷射雕刻機:功能說明及使用製程',
  },
  {
    id: 13,
    image: require('../images/ServiceImg/Equipment/G-21-LaserCuttingMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/G-21-激光雕刻机.jpg',
    alt: 'images/ServiceImg/Equipment/G-21-LaserCuttingMachine.jpg',
    name: 'XXXXXXXX',
    title: '激光雕刻机',
    subtitle: 'Laser Cutting Machine',
    describe: '激光机切割机',
    detail: '雷射雕刻機:功能說明及使用製程',
  },
  {
    id: 14,
    image: require('../images/ServiceImg/Equipment/G-29-GlassCutter.jpg'),
    // alt: 'images/ServiceImg/Equipment/G-29-玻璃切割机.jpg',
    alt: 'images/ServiceImg/Equipment/G-29-GlassCutter.jpg',
    name: 'Glass Cutting Machine',
    title: '玻璃切刻機',
    subtitle: 'Glass Cutting Machine',
    detail: '玻璃切刻機:功能說明及使用製程',
    describe: '玻璃切刻機',
  },
  {
    id: 15,
    image: require('../images/ServiceImg/Equipment/F-15-ACFAttachEquipment.jpg'),
    // alt: 'images/ServiceImg/Equipment/F-15-ACF热贴附机.jpg',
    alt: 'images/ServiceImg/Equipment/F-15-ACFAttachEquipment.jpg',
    name: 'ACF Pre-Bonding Machine',
    title: 'ACF Pre-Bonding Machin',
    subtitle: 'ACF Pre-Bonding Machine',
    describe: 'ACF預貼附設備',
    detail: 'FPC熱壓前ACF預貼附定位',
  },
  {
    id: 16,
    image: require('../images/ServiceImg/Equipment/F-16-FPCBondingMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/F-16-FPC热压机.jpg',
    alt: 'images/ServiceImg/Equipment/F-16-FPCBondingMachine.jpg',
    name: 'FPC Bonding Machine',
    title: 'FPC熱壓機',
    subtitle: 'FPC Bonding Machine',
    detail: 'FPC熱壓機:功能說明及使用製程',
    describe: 'FPC熱壓機',
  },
  // {
  //   id: 17,
  //   image: require('../images/ServiceImg/Equipment/E-11-10inchLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-11-10吋贴片机.jpg',
  //   // alt: 'images/ServiceImg/Equipment/E-11-10inchLaminator.jpg',
  //   name: 'Cover+Sensor Lamination Machine',
  //   title: '10.0(Small)吋贴片机',
  //   subtitle: 'Cover+Sensor Lamination Machine',
  //   describe: '貼合機',
  //   detail: '蓋板+功能片貼合機，應用於OCA貼合',
  // },
  {
    id: 18,
    image: require('../images/ServiceImg/Equipment/E-11-10inchLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-11-10吋贴片机.jpg',
    alt: 'images/ServiceImg/Equipment/E-11-10inchLaminator.jpg',
    name: 'Cover+Sensor Lamination Machine',
    title: '10.0吋(Small)盖板+功能片贴片机',
    subtitle: 'Cover+Sensor Lamination Machine',
    describe: '蓋板+功能片 SCA 貼合機',
    detail: '蓋板+功能片貼合機，應用於SCA & OCA 貼合',
  },
  // {
  //   id: 19,
  //   image: require('../images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-13-15吋翻板贴合机.jpg',
  //   // alt: 'images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
  //   name: 'Cover+Sensor Lamination Machine',
  //   title: '15.0吋(Middle)翻板贴合机',
  //   subtitle: 'Cover+Sensor Flap Lamination Machine',
  //   describe: '自动贴合机',
  //   detail: '蓋板+功能片貼合機',
  // },
  {
    id: 20,
    image: require('../images/ServiceImg/Equipment/D-08-AutoClaveMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/D-08-高压消泡机.jpg',
    alt: 'images/ServiceImg/Equipment/D-08-AutoClaveMachin.jpg',
    name: 'Auto Clave Machine',
    title: 'Auto Clave Machine',
    subtitle: '高压消泡机',
    describe: '脱泡机',
    detail: '利用壓力及溫度去除黏合面所產生氣泡',
  },
  // {
  //   id: 21,
  //   image: require('../images/ServiceImg/Equipment/D-22-AutoClaveMachine.jpg'),
  //   alt: 'images/ServiceImg/Equipment/D-22-高压脱泡机.jpg',
  //   // alt: 'images/ServiceImg/Equipment/D-22-AutoClaveMachine.jpg',
  //   name: 'XXXXXXXX',
  //   title: '高压脱泡机',
  //   subtitle: 'Presure Auto Clave Machine',
  //   describe: '脱泡机',
  //   detail: 'XXXXXXXX',
  // },
  {
    id: 22,
    image: require('../images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-13-15吋翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
    name: 'Flap laminating machine',
    title: '15.0吋(Middle)翻板貼合機',
    subtitle: '15 inch Flip Plate Laminator',
    describe: '中尺寸(15.6吋)翻板貼合機',
    detail: '12~18“吋(中尺寸)翻板貼合機',
  },
  {
    id: 23,
    image: require('../images/ServiceImg/Equipment/E-10-7inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-10-7.0吋翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-10-7inchFlipPlateLaminator.jpg',
    name: 'Flap laminating machine',
    title: '7.0吋(Small)翻板贴合机',
    subtitle: '7.0 inch Flip Plate Laminator',
    describe: '翻板贴合机-Small',
    detail: '5~9吋(小尺寸)翻板贴合机',
  },
  {
    id: 24,
    image: require('../images/ServiceImg/Equipment/E-40-21inchLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-40-21吋贴片机.jpg',
    alt: 'images/ServiceImg/Equipment/E-40-21inchLaminator.jpg',
    name: 'Flap laminating machine',
    title: '中大尺寸(21.5吋)翻板貼合機',
    subtitle: '21.5 inch Lamination Machine',
    describe: '中尺寸(21.5吋)翻板貼合機',
    detail: '18~27吋(中大尺寸)翻板貼合機',
  },
  // {
  //   id: 25,
  //   image: require('../images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg'),
  //   alt: 'images/ServiceImg/Equipment/E-13-15吋翻板贴合机.jpg',
  //   // alt: 'images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
  //   name: 'XXXXXXXX',
  //   title: '15.0吋翻板贴合机',
  //   subtitle: '15.0 inch Flip Plate Laminator',
  //   describe: '翻板贴合机 Middle',
  //   detail: '10~21_吋翻板贴合机',
  // },
  {
    id: 26,
    image: require('../images/ServiceImg/Equipment/E-14-32inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-14-32吋翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-14-32inchFlipPlateLaminator.jpg',
    name: 'Flap laminating machine',
    title: '32吋(大尺寸)翻板貼合機',
    subtitle: '32 inch Flip Plate Laminator',
    describe: '大尺寸(32.0吋)翻板貼合機',
    detail: '27~40吋(大尺寸)翻板貼合機',
  },
  {
    id: 27,
    image: require('../images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-12-15吋双工位翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-12-15inchFlipPlateLaminator.jpg',
    name: 'XXXXXXXX',
    title: '15.0吋双工位翻板贴合',
    subtitle: '15.0 inch FlipPlateLaminator',
    describe: '翻板贴合机 Large',
    detail: '15.0吋双工位翻板贴合',
  },
  // {
  //   id: 28,
  //   image: require('../images/ServiceImg/Equipment/ServSensorEquip-4.jpg'),
  //   alt: 'images/ServiceImg/Equipment/ServSensorEquip-4.jpg',
  //   name: 'xxxxxxxxxx machine',
  //   title: '除膠機',
  //   describe: '除膠機',
  //   detail: '除膠機',
  // },
  // {
  //   id: 29,
  //   image: require('../images/ServiceImg/Equipment/ServSensorEquip-4.jpg'),
  //   alt: 'images/ServiceImg/Equipment/ServSensorEquip-4.jpg',
  //   name: 'xxxxxxxxxx machine',
  //   title: '貼膜機',
  //   describe: '貼膜機',
  //   detail: '貼膜機',
  // },
  // {
  //   id: 30,
  //   image: require('../images/ServiceImg/Equipment/ServSensorEquip-4.jpg'),
  //   alt: 'images/ServiceImg/Equipment/ServSensorEquip-4.jpg',
  //   name: 'xxxxxxxxxx machine',
  //   title: '覆膜機',
  //   describe: '覆膜機',
  //   detail: '覆膜機',
  // },
  {
    id: 31,
    image: require('../images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg'),
    // alt: 'images/ServiceImg/Equipment/E-13-15吋翻板贴合机.jpg',
    alt: 'images/ServiceImg/Equipment/E-13-15inchFlipPlateLaminator.jpg',
    name: 'xxxxxxxxxx machine',
    title: '15.6吋真空貼合機',
    subtitle: '15.6 inch Vacuum Lamination Machine',
    describe: '15.6吋真空貼合機',
    detail: '15.6吋真空貼合機',
  },
  // {
  //   id: 32,
  //   image: require('../images/ServiceImg/Equipment/ServSensorEquip-4.jpg'),
  //   alt: 'images/ServiceImg/Equipment/ServSensorEquip-4.jpg',
  //   name: 'xxxxxxxxxx machine',
  //   title: 'OCA貼合機',
  //   describe: 'OCA貼合機',
  //   detail: 'OCA貼合機',
  // },
  {
    id: 33,
    image: require('../images/ServiceImg/Equipment/I-18-TPTestingEquipment.jpg'),
    // alt: 'images/ServiceImg/Equipment/I-18-TP电气功能测试设备.jpg',
    alt: 'images/ServiceImg/Equipment/I-18-TPTestingEquipment.jpg',
    name: 'Touch Panel Testing Equipment',
    title: '触摸屏電氣功能測試設備',
    subtitle: 'Touch Panel Testing Equipment',
    describe: '電氣功能測試設備',
    detail: 'Touch Panel 電氣功能測試設備',
  },
  {
    id: 34,
    image: require('../images/ServiceImg/Equipment/I-38-SensorTestingMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/I-38-Sensor假压测试机.jpg',
    alt: 'images/ServiceImg/Equipment/I-38-SensorTestingMachine.jpg',
    name: 'Sensor Pre-bonding test equipment',
    title: '功能片假压测试机',
    subtitle: 'Sensor Pre-bonding test equipment',
    describe: '假压测试設備',
    detail: '功能片假压测试机，短断路功能测试',
  },
  {
    id: 35,
    image: require('../images/ServiceImg/Equipment/I-36-TPTestingMachine.jpg'),
    // alt: 'images/ServiceImg/Equipment/I-36-TP电气功能测试设备.jpg',
    alt: 'images/ServiceImg/Equipment/I-36-TPTestingMachine.jpg',
    name: 'TP Functional test equipment',
    title: '触摸屏电器功能测试设备',
    subtitle: 'Touch Panel Functional Test Equipment',
    describe: '電氣功能測試設備',
    detail: '触摸屏电器功能测试设备:功能說明及使用製程',
  },
  {
    id: 36,
    image: require('../images/ServiceImg/Equipment/J-07-2DMeasureInstrument.jpg'),
    // alt: 'images/ServiceImg/Equipment/J-07-二次元检测仪.jpg',
    alt: 'images/ServiceImg/Equipment/J-07-2DMeasureInstrument.jpg',
    name: '2D Measurement Instrument',
    title: '二次元检测仪：',
    subtitle: '2D Measurement Instrument',
    describe: '二次元检测仪',
    detail: '二次元检测仪',
  },
  {
    id: 37,
    image: require('../images/ServiceImg/Equipment/H-24-HTempAgingChamber.jpg'),
    // alt: 'images/ServiceImg/Equipment/H-24-高温老化试验箱.jpg',
    alt: 'images/ServiceImg/Equipment/H-24-HTempAgingChamber.jpg',
    name: 'Functional test equipment',
    title: '恒溫恒濕試驗箱',
    subtitle: 'High Temperature Aging Chamber',
    describe: '恒溫恒濕試驗箱',
    detail: '恒溫恒濕試驗箱; 加速老化实验测试',
  },
  {
    id: 38,
    image: require('../images/ServiceImg/Equipment/H-25-HLTempTestChamber.jpg'),
    // alt: 'images/ServiceImg/Equipment/H-25-高低温测试设备.jpg',
    alt: 'images/ServiceImg/Equipment/H-25-HLTempTestChamber.jpg',
    name: 'Functional test equipment',
    title: '高低溫濕熱試驗箱',
    subtitle: 'High Low Temp Test Chamber',
    detail: '高低溫濕熱試驗箱',
    describe: '高低溫濕熱試驗箱',
  },
  {
    id: 39,
    image: require('../images/ServiceImg/Equipment/H-31-ThermalShockChamber.jpg'),
    // alt: 'images/ServiceImg/Equipment/H-31-冷热冲击测试机.jpg',
    alt: 'images/ServiceImg/Equipment/H-31-ThermalShockChamber.jpg',
    name: 'Functional test equipment',
    title: '冷熱衝擊測試設備',
    subtitle: 'Thermal Shock Test kChamber',
    detail: '冷熱衝擊測試設備',
    describe: '冷熱衝擊測試設備',
  },
  // {
  //   // 3.2.	環測設備
  //   id: 40,
  //   image: require('../images/ServiceImg/Equipment/ServSensorEquip-8.jpg'),
  //   alt: 'images/ServiceImg/Equipment/ServSensorEquip-8.jpg',
  //   name: 'Functional test equipment',
  //   title: '跌落測試機',
  //   detail: '跌落測試機',
  //   describe: '跌落測試機',
  // },
  // {
  //   // 3.2.	環測設備
  //   id: 41,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX Instrument',
  //   title: '氙燈老化實驗機',
  //   describe: '氙燈老化實驗機',
  //   detail: '氙燈老化實驗機',
  // },
  // {
  //   // 3.2.	環測設備
  //   id: 42,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX Instrument',
  //   title: '鹽霧實驗箱',
  //   describe: '鹽霧實驗箱',
  //   detail: '鹽霧實驗箱',
  // },
  {
    // 3.3.	檢測設備
    id: 43,
    image: require('../images/ServiceImg/Equipment/J-17-2DMeasureInstrument.jpg'),
    // alt: 'images/ServiceImg/Equipment/J-17-二次元检测仪.jpg',
    alt: 'images/ServiceImg/Equipment/J-17-2DMeasureInstrument.jpg',
    name: '2D Measuring Instrument',
    title: '二次元影像量测仪',
    subtitle: '2D Measuring Instrument',
    describe: '二次元影像測試儀',
    detail: '以影像放大量測尺寸',
  },
  // {
  //   // 3.3.	檢測設備
  //   id: 43,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX',
  //   title: '晶像儀',
  //   describe: '晶像儀',
  //   detail: '晶像儀',
  // },
  // // {
  // //   // 3.3.	檢測設備
  // //   id: 44,
  // //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  // //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  // //   name: 'XXXXXXXX',
  // //   title: 'Sensor線路放大檢測設備',
  // //   describe: 'Sensor線路放大檢測設備',
  // //   detail: 'Sensor線路放大檢測設備',
  // // },
  // // {
  // //   // 3.3.	檢測設備
  // //   id: 45,
  // //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  // //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  // //   name: 'XXXXXXXX',
  // //   title: '應力測試儀',
  // //   describe: '應力測試儀',
  // //   detail: '應力測試儀',
  // // },
  // {
  //   // 3.3.	檢測設備
  //   id: 46,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX',
  //   title: '電動鉛筆硬度計',
  //   describe: '電動鉛筆硬度計',
  //   detail: '電動鉛筆硬度計',
  // },
  // {
  //   // 3.3.	檢測設備
  //   id: 47,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX',
  //   title: '拉力實驗機',
  //   describe: '拉力實驗機',
  //   detail: '拉力實驗機',
  // },
  // {
  //   // 3.3.	檢測設備
  //   id: 48,
  //   image: require('../images/ServiceImg/Equipment/二次元检测设备.jpg'),
  //   alt: 'images/ServiceImg/Equipment/二次元检测设备.jpg',
  //   name: 'XXXXXXXX',
  //   title: '靜電放電發生器',
  //   describe: '靜電放電發生器',
  //   detail: '靜電放電發生器',
  // },
]

export const ServDevelopFactoryArea = [
  {
    id: 1,
    image: require('../images/ServiceImg/Area/PreProductionLine.png'),
    // image: require('../images/ServiceImg/Area/ServPreProdLine-1.png'),
    alt: 'images/ServiceImg/Area/PreProductionLine.png',
    name: 'Pre-Production Line',
    // name: '４.１.前段生產線(9F)',
    title: '前段生產線(9F)',
    subtitle: '前段生產線(9F)',
    text:
      '       印刷生產線：Class 100~1000，穿著無塵衣，23℃\n' +
      '       蝕刻清洗線：Class 1000~10000，穿著無塵衣，23℃\n' +
      '       無塵烤箱區：Class 1000~10000，穿著無塵衣，26℃\n' +
      '       雷射雕刻房：Class 10000~100000，穿著工作服，25℃\n' +
      '       外觀檢驗區：Class 10000~100000，穿著工作服，25℃\n' +
      '       功能測試區：Class 10000~100000，穿著工作服，25℃\n' +
      '       加工區域：Class 10000~100000，穿著工作服，25℃\n' +
      '       原料線邊倉：Class 1000~10000，25℃\n' +
      '       成品倉：Class 10000~100000，25℃\n' +
      '\n',
    describe: 'Service Develop Pre-Production Line',
    link: '',
    time: '2025/8/18',
  },
  {
    id: 2,
    image: require('../images/ServiceImg/Area/PostProductionLine.png'),
    // image: require('../images/Area/ServAreaPostLine.png'),
    alt: 'images/ServiceImg/Area/PostProductionLine.png',
    name: 'Post-Production Line',
    // name: '4.2.	後段生產線(9F)',
    title: '後段生產線(9F)',
    subtitle: '後段生產線(9F)',
    text:
      '        貼合生產線：Class 100~1000，穿著無塵衣，23℃\n' +
      '        熱壓生產線：Class 1000~10000，穿著無塵衣，23℃\n' +
      '        玻璃切割間：Class 10000~100000，穿著工作服，25℃\n' +
      '        雷射雕刻機房：Class 10000~100000，穿著工作服，25℃\n' +
      '        脫泡機房：Class 10000~100000，穿著工作服，26℃\n' +
      '        加工區域(9F) ：Class 10000~100000，穿著工作服，25℃\n' +
      '        外觀檢驗區：Class 10000~100000，穿著工作服，25℃\n' +
      '        功能測試區：Class 10000~100000，穿著工作服，25℃\n' +
      '        原料/成品線邊倉：Class 10000~100000，25℃\n' +
      '\n',
    describe: 'Service Develop Post-Production Line',
    link: '',
    time: '2025/8/18',
  },
  {
    id: 3,
    image: require('../images/ServiceImg/Area/OfficeWorkingArea.png'),
    // image: require('../images/ServiceImg/Area/OfficeWorkingArea.png'),
    alt: 'images/ServiceImg/Area/OfficeWorkingArea.png',
    name: '辦公工作區域(8F)',
    // name: 'Assist Working Area',
    title: '辦公工作區域(8F)',
    subtitle: '辦公工作區域(8F)',
    text:
      '        接待大堂\n' +
      '        总经理室\n' +
      '        业务部\n' +
      '        行政區：人事、總務、資材\n' +
      '        廠務區：工程部、生產部、品質部\n' +
      '        會議室\n' +
      '\n',
    // nameEng: '',
    // titleEng: '',
    // subtitleEng: '',
    // textEng:
    //   '\n' +
    //   '\n',
    describe: 'Service Develop Working Area',
    link: '',
    time: '2025/3/6',
  },
]

/*
export const ServDevelopTPMEquip = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'images/ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Production Equipment',
    title: '生產設備',
    subtitle: 'P-Cap Touch 生產設備',
    text:
      '     ＊ 投射電容觸控面板生產設備：\n' +
      '          • OCA翻板貼合機\n' +
      '          • 電氣功能測試設備\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/2/20',
  },
]
*/

/*
export const ServDevelopTDMEquip = [
  {
    id: 0,
    // image: require('../images/ServiceImg/ServDevelopXxxxxxxxxx.png'),
    // alt: 'images/ServiceImg/ServDevelopXxxxxxxxxx.png',
    name: 'Production Equipment',
    title: '生產設備',
    subtitle: 'Touch Display 生產設備',
    text:
      '     ＊ TP+LCM全貼合生產設備：\n' +
      '          • 真空壓合機\n' +
      '          • 貼合脫泡機\n' +
      '          • UV固化機\n' +
      '\n',
    describe: '',
    link: '',
    time: '2025/2/20',
  },
]
*/

/*
export const ServDevelopEquipProd = [
  {
    id: 1,
    // image: require('../images/ServEquipImg/touchCtrl-1.png'),
    // alt: 'images/ServEquipImg/touchCtrl-1.png',
    name: 'Production Equipment',
    title: '生产设备',
    // subtitle: '',
    text:
      '\n' +
      '  網板印刷機(大尺寸，如65吋以上)：\n' +
      '     印刷機構設計優化，網版設計距絲印產品1~3mm,印刷過程中變形小，尺寸更穩定，網版壽命更高\n' +
      '     全過程雙人工放片，避免因尺寸過大，在作業過程中造成破損或其他不良，印刷良率高\n' +
      '  蝕刻清洗機：\n' +
      '     提升產品良率與可靠性：通過精准控制清洗力度(如噴淋壓力、超聲頻率)和清洗介質(如純水、化學清洗劑)，\n' +
      '     在高效去汙的同時避免損傷工件表面(如ITO 膜層、半導體線路)，減少因污染或腐蝕導致的產品缺陷，\n' +
      '     適配高精度電子元件對表面潔淨度的嚴苛要求\n' +
      '  UV固化機：\n' +
      '     在觸摸屏(Touch Panel)的生產製造中，UV固化機通過紫外線照射引發UV固化材料(如油墨、膠水、塗層等)的化學聚合反應，\n' +
      '     實現材料快速固化，是保障TP性能、精度和生產效率的關鍵設備\n' +
      '  無塵烤箱：\n' +
      '     結合"潔淨環境+精准溫控"，其作用不僅是完成加熱、烘乾、固化等基礎工藝，在處理過程中杜絕微粒污染並保證工藝一致性，\n' +
      '     從而保障高精密產品的性能可靠性和生產良率。在半導體、電子等高端製造領域，它是實現精細化生產的關鍵設備之一\n' +
      '  翻板貼合機：\n' +
      '      ＊ 高精度對位貼合：\n' +
      '      ＊ 無氣泡貼合：\n' +
      '      ＊ 適配輕薄材料：\n' +
      '      ＊ 提升生產效率：\n' +
      ''
  }
]
*/

/*
export const ServDevelopEquipEnviron = [
  {
    id: 1,
    // image: require('../images/ServEquipImg/touchCtrl-1.png'),
    // alt: 'images/ServEquipImg/touchCtrl-1.png',
    name: 'Environmental Testing Equipment',
    title: '环测设备',
    // subtitle: '',
    text:
      '          ***生產設備***\n' +
      '          • 網版印刷機' +
      '          • 蝕刻清洗機' +
      '          • 電氣功能測試設備\n' +
      '\n' +
      '          ***環測設備***\n' +
      '          • 高溫測試設備' +
      '          • 低溫測試設備' +
      '          • 高溫高濕測試設備' +
      '          • 冷熱衝擊測試設備' +
      '\n',
    describe: 'Production Equipment',
  },
]
*/

/*
export const ServDevelopEquipTesting = [
  {
    id: 1,
    // image: require('../images/ServEquipImg/touchCtrl-1.png'),
    // alt: 'images/ServEquipImg/touchCtrl-1.png',
    name: 'Testing/Detection Equipment',
    title: '检测設備',
    // subtitle: '',
    text:
      '          ***生產設備***\n' +
      '          • 網版印刷機' +
      '          • 蝕刻清洗機' +
      '          • UV固化機' +
      '          • 電氣功能測試設備\n' +
      '\n' +
      '          ***環測設備***\n' +
      '          • 高溫測試設備' +
      '          • 低溫測試設備' +
      '          • 高溫高濕測試設備' +
      '          • 冷熱衝擊測試設備' +
      '\n',
    describe: 'Production Equipment',
  },
]
*/